<ng-container *ngIf="(graphic$ | async) as graphic">
  <img *ngIf="graphic.image"
       [class]="imageClasses" class="catalog-image"
       [ngStyle]="{'max-height': imageSize+'px', 'max-width': imageSize+'px'}"
       src="data:image/png;base64,{{graphic.image}}" alt=""/>
</ng-container>
